/* eslint-disable import/no-cycle */
let timeout = -1;

window.addEventListener('resize', () => {
  if (!document.documentElement.classList.contains('no-transition')) {
    document.documentElement.classList.add('no-transition');
  }
  if (timeout !== -1) { clearTimeout(timeout); }
  timeout = setTimeout(() => {
    timeout = -1;
    if (document.documentElement.classList.contains('no-transition')) {
      document.documentElement.classList.remove('no-transition');
    }
  }, 0);
});
